const locationUrl = window.location.href;
const getPgEndpoint = (): string => {
	if (locationUrl.includes('bp-pg.bharatpe.io')) return 'https://payment-gateway.bharatpe.io';
	if (locationUrl.includes('bp-pg-uat.bharatpe.in')) return 'https://payment-gateway-pp.bharatpe.in';
	if (locationUrl.includes('bp-pg-uat1.bharatpe.in')) return 'https://payment-gateway.bharatpe.co.in';
	return 'https://payment-gateway.bharatpe.in';
};

const base_url = getPgEndpoint();

export const API_URL = {
	payment_mode: `${base_url}/v1/transaction/`,
	payment_status: locationUrl.includes('bp-pg-uat1.bharatpe.in')
		? `${base_url}/qa/transaction/`
		: `${base_url}/v1/transaction/`,
	verify_otp: `${base_url}/v1/transaction/generate-otp`,
	resend_otp: `${base_url}/v1/transaction/resend-otp`,
	getPaymentModesV2: `${base_url}/v2/transaction/`,
	get_cashback: 'https://api-postpe.bharatpe.in/postpe/v1/cashback',
	apply_cashback: 'https://api-postpe.bharatpe.in/postpe/v1/cashback/apply',
	toggle_postpe_cashback: 'https://api-postpe.bharatpe.in/postpe/v1/cashback',
	get_card_info: 'https://payment-gateway.bharatpe.in/v1/shared/card-data',
};
